import { FC } from 'react';
import { Dropdown, DropdownItemProps, DropdownProps } from 'semantic-ui-react';

class Group {
    name: string = '';
    subGroups: Record<string, Group> = {};
    values: string[] = [];

    constructor(name: string = '') {
        this.name = name;
    }

    add(value: string, path: string[]) {
        if (path.length === 0) {
            this.values.push(value);
            return this;
        }

        const head = path[0];
        const subPath = path.slice(1);
        if (head in this.subGroups) {
            this.subGroups[head].add(value, subPath);
        }
        else {
            this.subGroups[head] = new Group(head).add(value, subPath);
        }

        return this;
    }

    getCurrentPath(curItem: string){
        try{
            const path_array = this.values[0].split('/');
            path_array.splice(path_array.length - 1, 1, curItem);
            const path = path_array.join('/')+'/%'
            return path
            }catch (e)
            {
            if (this.subGroups[curItem].values.length===0){
                const path = '%/'+this.name+'/'+curItem+'/%'
                return path
            }
            else{
                const path_array = this.subGroups[curItem].values[0].split('/')
                path_array.splice(path_array.length - 1, 1);
                const path = path_array.join('/')+'/%'
                return path
            }

            }
    }
}


type ItemClick = (value: string) => void;


const GroupView: FC<{ group: Group, itemClick: ItemClick } & DropdownProps> = props => {
    const { group, itemClick, ...rest } = props;
    const items = Object.keys(group.subGroups).concat(group.values).sort();

    return (
        <Dropdown text={group.name} {...rest} >

            <Dropdown.Menu>
                {items.map(item => {
                    if (item in group.subGroups) {
                        const groupClick = (event: any) => {
                            if (event.ctrlKey){
                                itemClick(group.getCurrentPath(item));
                            }
                        };

                        return (
                            <Dropdown.Item key={item} >
                                <GroupView
                                    group={group.subGroups[item]}
                                    itemClick={itemClick}
                                    onClick={groupClick}
                                />
                            </Dropdown.Item>
                        )
                    }
                    return (
                        <Dropdown.Item key={item} onClick={() => itemClick(item)} value={item}>
                            <div className='test'>
                                {item.split('/').reverse()[0]}
                            </div>
                        </Dropdown.Item>
                    );
                })}
            </Dropdown.Menu>
        </Dropdown>
    );
};


const StructuredDropdown: FC<{ values: string[], itemClick: ItemClick } & DropdownProps> = props => {
    const { values, ...rest } = props;

    const root = new Group();

    values.forEach(o => {
        const path = o.split('/').slice(2);
        path.splice(path.length - 1, 1);
        root.add(o, path);
        
    });

    return (
        <GroupView group={root} {...rest} />
    );
};

export default StructuredDropdown;